<template>
  <div>
    <v-banner
      v-for="(video, index) in data"
      :index="index"
      :key="index"
      :sticky="false"
      single-line
      icon-color="white"
      color="white"
      :elevation="3"
      class="mb-2"
    >
      <v-avatar size="36px">
        <img alt="Avatar" :src="video.image" />
      </v-avatar>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">{{ video.title }}</span>
        </template>
        <span>{{ video.title }}</span>
      </v-tooltip>

      <template v-slot:actions>
        <!--
        <video-route
          :video="video"
          :blockId="sectionSelectedBlockId"
          :sectionId="sectionSelectedId"
          :fontColor="sectionSelected.settings.style.fontColor"
        >
          <template #link>
            <v-icon>play_arrow</v-icon>
          </template>
        </video-route>
        -->
        <v-btn
          :to="{
            name: 'watch',
            params: { sectionId: sectionSelectedId, blockId: sectionSelectedBlockId, videoId: video.id }}"
          class="ma-2"
          color="primary"
          fab
          outlined
          small
        >
          <v-icon>play_arrow</v-icon>
        </v-btn>
      </template>

    </v-banner>
  </div>
</template>
<script>
  import {vmImage, vmImageBackground} from '@fremcast/section/Image';
  import {videoRoute, iconRoute} from '@fremcast/section/RouteLink';
  import FremcastImage from "@fremcast/section/ImageVideoCard";
  import section from '@fremcast/section/mixins/section';
  import card from '@fremcast/section/mixins/card';
  import * as SectionsConfig from '@fremcast/section/config';
  import stylesButton from "@fremcast/section/mixins/stylesButton";

  export default {
    data() {
      return {
        sectionSelectedId: 0,
        //sectionTextColor: "#FFF",
        blockStyle: 'Card',
        sectionSelectedBlockId: 0
      };
    },
    created() {
      this.blockStyle = this.sectionSelected.settings.blockStyle;
      this.textColor = this.sectionSelected.titleColor;
      this.sectionSelectedId = this.sectionSelected.sectionId;
      this.sectionSelectedBlockId = this.sectionSelected.id
    },
    props: [
      'data',
      'css'
    ],
    components: {
      //vmImage,
      videoRoute,
      //vmImageBackground,
      iconRoute,
      //FremcastImage
    },
    mixins: [
      section,
      card,
      stylesButton
    ],
    watch: {
      sectionSelected: {
        handler: function (value) {
          this.blockStyle = value.settings.blockStyle;
        },
        deep: true
      }
    }
  }
</script>
